import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Paper from '@mui/material/Paper';
import apiClient from "../../../lib/apiClient";
import BudgetItemForm from '../../../components/BudgetItemForm';

import { onError } from "../../../lib/errorLib";
import { useAppContext } from "../../../lib/contextLib";
import "./Items.css";

interface BudgetItemData {
  itemId: string;
  itemType: string;
  itemSubType: string;
  description: string;
  amount: string | number;
  frequency: string;
  [key: string]: unknown;
}

export default function Items() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { isAuthenticated } = useAppContext();
  const [itemType, setTypeOfItem] = useState("");
  const [budgetItem, setBudgetItem] = useState<BudgetItemData | null>(null);
  const [isLoading] = useState(false);

  useEffect(() => {
    function loadBudgetItem() {
      return apiClient.get("finance", `/items/${id}`);
    }

    async function onLoad() {
      try {
        const budgetItem = await loadBudgetItem() as BudgetItemData;
  const { itemType } = budgetItem;
  setTypeOfItem(itemType);

        setBudgetItem(budgetItem);
      } catch (e) {
        onError(e);
      }
    }

    onLoad();
  }, [id]);

  function handleSuccess(){
    if (itemType === 'income') navigate('/budget/income', { replace: true });
    else if (itemType === 'savings') navigate('/budget/savings', { replace: true });
    else if (itemType === 'expense') navigate('/budget/expenses', { replace: true });
    else navigate('/budget/overview', { replace: true });
  }

  function renderBudgetItemsList() {
  return (
    <div className="Items stack-lg">
      {budgetItem && (
        <BudgetItemForm
          mode='edit'
          initial={{ ...budgetItem, itemId: budgetItem.itemId, amount: budgetItem.amount, frequency: budgetItem.frequency }}
          fixedType={budgetItem.itemType}
          onSuccess={handleSuccess}
          enableDelete
        />
      )}
    </div>
  );
}

function renderLander() {
  return (
    <div className="lander">
      <h1>Making Budgets</h1>
      <p className="text-muted">A simple tool for making budgets</p>
    </div>
  );
}

function renderBudgetItems() {
  return (
    <div className="budgetItems stack-md">
      <div className="section-heading">Edit Item</div>
      <Paper variant="outlined" sx={{p:2}}>{!isLoading && renderBudgetItemsList()}</Paper>
    </div>
  );
}

return (
  <div className="Income">
    {isAuthenticated ? renderBudgetItems() : renderLander()}
  </div>
);
}
